var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightbulb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 26",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.42 5.06a7.358 7.358 0 0 0-7.36 7.36l.005.258a7.358 7.358 0 0 0 5.023 6.712l.112.035v.995a.5.5 0 0 0 .5.5h3.43l.09-.008a.5.5 0 0 0 .41-.492v-.995l.114-.034a7.343 7.343 0 0 0 5.036-6.97 7.358 7.358 0 0 0-7.36-7.36Zm0 1a6.358 6.358 0 0 1 6.36 6.36 6.345 6.345 0 0 1-4.774 6.146l-.08.028a.5.5 0 0 0-.296.456v.87H11.2v-.87a.5.5 0 0 0-.375-.484A6.356 6.356 0 0 1 6.06 12.42a6.358 6.358 0 0 1 6.36-6.36Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13 25h-1.15M14.14 22.71h-3.43M12.42 1v2.28M23.85 12.42h-2.28M1 12.42h2.28M3.53 3.54l2.43 2.42M21.31 3.54l-2.42 2.42"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightbulb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lightbulb.773fa82c88d0eb5d86ea7766acfe49ff.svg";